import React from "react";
import { RCCInputMask } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import IComponentInputNumber from "./interface";

const InputNumber: React.FC<IComponentInputNumber> = ({...rest}) => {
	const {currentLanguage} = useTranslation();
	if(currentLanguage === "pt" || currentLanguage === "es")
		return (
			<RCCInputMask 
				decimalSeparator=","
				thousandSeparator="."
				decimalScale={2}
				fixedDecimalScale
				{...rest}
			/>
		);

	return (
		<RCCInputMask 
			decimalSeparator="."
			thousandSeparator=","
			decimalScale={2}
			fixedDecimalScale
			{...rest}
		/>
	);
};

export default InputNumber;
